import './HomeSectionContainer.scss';

const HomeSectionContainer = ({ children, className }) => (
  <div className={`mx-auto mt-3 home-section-container ${className}`}>{children}</div>
);

export default HomeSectionContainer;
